import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo'; // ✅ YENİ EKLENDİ: SEO Bileşeni
import { ArrowRight, Calendar, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function BlogListPage() {
  const { t, language } = useLanguage();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${API}/blogs?published=true`);
      setBlogs(response.data);
    } catch (error) {
      console.error('Error fetching blogs:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(language === 'tr' ? 'tr-TR' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="min-h-screen">
      {/* ✅ YENİ EKLENDİ: Blog Sayfası SEO Ayarları */}
      <Seo 
        title="Blog & Haberler" 
        description="MERTT A.Ş. teknoloji, yazılım ve endüstriyel tasarım üzerine güncel makaleler, haberler ve duyurular."
      />

      <Navbar />

      <section className="pt-32 pb-20" data-testid="blog-list-section">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="font-emblema text-4xl sm:text-5xl lg:text-6xl text-gradient mb-4">
              {t('blog.title')}
            </h1>
          </div>

          {loading ? (
            <div className="flex justify-center">
              <div className="spinner"></div>
            </div>
          ) : blogs.length === 0 ? (
            <div className="text-center text-gray-400">
              <p>No blog posts available yet.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogs.map((blog, index) => (
                <Link
                  key={blog.id}
                  to={`/blog/${blog.id}`}
                  data-testid={`blog-card-${index}`}
                  className="card group cursor-pointer h-full flex flex-col"
                >
                  <div className="image-overlay rounded-lg mb-4 h-56">
                    <img
                      src={blog.image_url}
                      alt={language === 'tr' ? blog.title_tr : blog.title_en}
                      className="w-full h-full object-cover rounded-lg"
                    />
                  </div>
                  
                  <div className="flex items-center space-x-4 text-sm text-gray-400 mb-3">
                    <div className="flex items-center space-x-1">
                      <User size={14} />
                      <span>{blog.author}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Calendar size={14} />
                      <span>{formatDate(blog.created_at)}</span>
                    </div>
                  </div>

                  <h3 className="text-xl font-semibold text-cyan-400 mb-3">
                    {language === 'tr' ? blog.title_tr : blog.title_en}
                  </h3>
                  <p className="text-gray-400 text-sm line-clamp-3 mb-4 flex-grow">
                    {language === 'tr' ? blog.excerpt_tr : blog.excerpt_en}
                  </p>
                  <div className="flex items-center text-cyan-400 group-hover:translate-x-2 transition-transform mt-auto">
                    <span className="text-sm">{t('blog.readMore')}</span>
                    <ArrowRight size={16} className="ml-2" />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BlogListPage;